<template>
  <Toolbar v-if="dataConfig.hasVariants || hasCallback || dataConfig.actionComponents">
    <template v-if="dataConfig.hasVariants">
      <ToolbarGroup v-if="false && item.children?.length">
        <a class="btn btn-light" href="" @click.prevent="$emit('update:childrenShown', !childrenShown)">
          <i class="fa-solid fa-chevron-down" v-if="!childrenShown"></i>
          <i class="fa-solid fa-chevron-up" v-else></i>
        </a>
      </ToolbarGroup>
      <ToolbarGroup v-if="item.linkParamsChild">
        <router-link  class="btn btn-primary" :to="item.linkParamsChild">
          <i class="fa-solid fa-plus"></i>
        </router-link>
      </ToolbarGroup>
    </template>
    <component v-for="comp in dataConfig.actionComponents || []" :is="comp" :item="item" />
    <ToolbarGroup v-if="hasCallback">
      <button @click.prevent="callCallback" class="btn">Use</button>
    </ToolbarGroup>
  </Toolbar>
<!--  {{ dataConfig.hasVariants ? "Has Variants" : "Simple" }} -->
</template>

<script>
export default {
  props: ["dataConfig", "item", "column", "childrenShown", "shownChildren"],
  computed: {
    hasCallback() {
      return this.$route.path.split("/").length>3;
      return !!this.stores.callbacks.lastCallback;
    },
  },
  methods: {
    callCallback() {
      if (this.hasCallback) {
        this.stores.callbacks.lastCallback(this.item);
        this.stores.callbacks.popCallback();
        this.$router.go(-1);
      }
    },
  },

}
</script>
